import { render, staticRenderFns } from "./Subambit.vue?vue&type=template&id=72a6a26a&scoped=true&"
import script from "./Subambit.vue?vue&type=script&lang=js&"
export * from "./Subambit.vue?vue&type=script&lang=js&"
import style0 from "./Subambit.vue?vue&type=style&index=0&id=72a6a26a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6a26a",
  null
  
)

export default component.exports